/**
 * 整个app的路由设置
 */
import Vue from 'vue'
//import api from '../api/index'

import VueRouter from 'vue-router'
//import { mapGetters } from 'vuex'

// import { mapGetters } from 'vuex'
// import api from '../api/index'

// 分离页面
// component: resolve => require(['../views/search/homeList'], resolve),


Vue.use(VueRouter)
const router = new VueRouter({
    // base:'/kosmos/',
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        //404
        {
            path: '*',
            component: require('../views/err/404'),
        },
        //首页
        {
            path: '/',
            component: require('../views/home/home'),

            children: [{
                path: '',
                component: require('../views/home/index'),

            }]
        },
        {
            path: '/home',
            component: require('../views/home/home'),
            children: [{
                path: 'index',
                component: require('../views/home/index')
            },
            {
                path: 'jdIndex',
                component: require('../views/home/jdIndex')
            },

            {
                // 酒店列表
                path: '/search/list',
                component: require('../views/search/list')
            },

            {
                path: 'user',
                component: require('../views/user/index')
            }, {
                path: 'order',
                component: require('../views/order/index')
            }, {
                path: 'IndexToOther',
                component: require('../views/order/IndexToOther')
            }, {
                path: 'wallet',
                component: require('../views/wallet/index')
            },
            // 登录注册 + 忘记密码
            {
                path: '/user/Login',
                component: require('../views/user/NonVerified/Login')
            },
            {
                path: '/user/2020SpringLogin',
                component: require('../views/user/NonVerified/2020SpringLogin')
            },
            {
                path: '/user/Register',
                component: require('../views/user/NonVerified/Register')
            },
            //联合登录 - 接收第三方回传
            {
                path: '/uniteLogin/UniteAccept',
                component: require('../views/uniteLogin/UniteAccept')
            },
            //联合登录 - 绑定第三方账号
            {
                path: '/uniteLogin/BindAccount',
                component: require('../views/uniteLogin/bindAccount')
            },
            {
                //  activity  持卡注册  
                path: '/user/CardHolderRegister',
                component: require('../views/user/NonVerified/CardHolderRegister')
            },
            { // 非会员查询订单
                path: '/user/OtherUser',
                component: require('../views/user/NonVerified/OtherUser')
            },
            { // 忘记密码
                path: '/user/ForgotPass',
                component: require('../views/user/NonVerified/ForgotPass')
            },
            // END 登录注册
            //  用户中心
            {
                path: '/user/UserCenter',
                component: require('../views/user/UserCenter')
            },
            {
                path: 'CloudWeApp',
                component: require('../views/home/CloudWeApp')
            }
                //  用户中心  END
            ]
        },


        //  休闲房 
        {
            path: '/search/ListToRelax',
            component: require('../views/search/ListToRelax')
        },
        { // 房间列表
            path: '/search/homeListToRelax',
            component: require('../views/search/homeListToRelax')
        },
        { // 房间列表
            path: '/search/makeOrderToRelax',
            component: require('../views/search/makeOrderToRelax')
        },
        {
            path: '/search/selectCity',
            component: require('../views/search/selectCity')
        },
        {
            path: '/search/key',
            component: require('../views/search/selectKey')
        },
        {
            // 酒店列表
            path: '/search/list',
            component: require('../views/search/list')
        },
        {
            // 房间列表
            path: '/search/homeList',
            component: require('../views/search/homeList')

        },
        {
            // 酒店介绍
            path: '/search/hotailDetail',
            component: require('../views/search/hotailDetail')
        },
        {
            // 酒店评论
            path: '/hotel/CommentList',
            component: resolve => require(['../views/comments/hotelComments'], resolve),
            // component: require('../views/comments/hotelComments')
        },
        {
            // 酒店评论 - 我来评论
            path: '/hotel/DoComment',
            component: resolve => require(['../views/hotel/DoComment'], resolve),
            // component: require('../views/hotel/DoComment')
        },
        {
            // 地图周边
            path: '/search/mapbook',
            component: require('../views/search/mapbook')
        },
        {
            // 地图预定
            path: '/search/mapSearch',
            // component: require('../views/search/mapSearch')
            component: require('../views/search/nearbyHotels')
        },
        {
            // 附近酒店
            path: '/search/nearbyHotels',
            component: require('../views/search/nearbyHotels')
        },


        {
            // 填写订单
            path: '/search/makeOrder',
            component: resolve => require(['../views/search/makeOrder'], resolve),
            // component: require('../views/search/makeOrder')
        },

        {
            // 填写早餐订单
            path: '/search/makeBreakfastOrder',
            component: require('../views/search/makeBreakfastOrder')
        },
        {
            // 填写早餐订单
            path: '/payOrder/breakfastPayType',
            component: require('../views/payOrder/breakfastPayType')
        },



        {
            // 订单提交成功
            path: '/search/orderSuccess',
            component: require('../views/search/orderSuccess')
        },

        { // 订单详情
            path: '/order/OrderDetails',
            // component: require('../views/order/OrderDetails')
            component: resolve => require(['../views/order/OrderDetails'], resolve),

        },
        { // 订单 - 支付房费
            path: '/order/PayMoney',
            component: require('../views/order/PayMoney')
        },
        { // 订单 - 支付房费 - 储值卡  1
            path: '/order/PayByStoredValueCard',
            component: require('../views/order/PayByStoredValueCard')
        },
        { // 订单 - 支付房费 - 银联支付 2  先确认用户打算用已有卡 OR 绑定新卡
            path: '/order/PayByUnion/ChooseCard',
            component: require('../views/order/PayByUnion/ChooseCard')
        },

        { // 订单 - 支付房费 - 银联支付 2  已有卡 - 直接支付
            path: '/order/PayByUnion/DirectPay',
            component: require('../views/order/PayByUnion/DirectPay')
        },

        { // 订单 - 支付房费 - 银联支付 2  先输入卡号，确定用户是 信用 OR 借记
            path: '/order/PayByUnion/BeforeBind',
            component: require('../views/order/PayByUnion/BeforeBind')
        },
        { // 订单 - 支付房费 - 银联支付 2  next信用卡
            path: '/order/PayByUnion/NextCredit',
            component: require('../views/order/PayByUnion/NextCredit')
        },
        { // 订单 - 支付房费 - 银联支付 2  next借记  
            path: '/order/PayByUnion/NextDebit',
            component: require('../views/order/PayByUnion/NextDebit')
        },
        { //支付 - 选择支付类型
            path: '/payOrder/payType',
            component: require('../views/payOrder/payType')
        },
        { //支付 -  京东支付提交信息
            path: '/payOrder/Jdpay',
            component: require('../views/payOrder/Jdpay')
        },

        { // 订单 - 支付房费 - 他人代付  4
            path: '/order/PayByOther',
            component: require('../views/order/PayByOther')
        },

        { // 订单 - 支付 - 成功
            path: '/order/PayIsOk',
            component: require('../views/order/PayIsOk')
        },



        { // 我的- 我的收藏
            path: '/user/MyCollection',
            component: require('../views/user/MyCollection')
        },
        { // 我的- 发票管理
            path: '/user/InvoiceManage',
            // component: require('../views/user/InvoiceManage')
            component: resolve => require(['../views/user/InvoiceManage'], resolve),

        },
        { // 我的- 早餐列表
            path: '/user/Breakfast',
            component: require('../views/user/Breakfast')
        },
        { // 我的- 早餐券详情
            path: '/user/BreakfastDetails',
            component: require('../views/user/BreakfastDetails')
        },

        {
            // 我的- 常住人员管理
            path: '/user/PassengerMsg',
            component: require('../views/user/PassengerMsg')
        },

        { // 我的- 我的收藏
            path: '/user/MyCollection',
            component: require('../views/user/MyCollection')
        },
        { // 我的- 发票管理
            path: '/user/InvoiceManage',
            component: require('../views/user/InvoiceManage')
        },
        { // 我的- 发票管理
            path: '/user/Breakfast',
            component: require('../views/user/Breakfast')
        },
        {
            // 我的- 常住人员管理
            path: '/user/PassengerMsg',
            component: require('../views/user/PassengerMsg')
        },

        { // 我的- 个人信息
            path: '/user/BaseInfo',
            component: require('../views/user/BaseInfo')
        },
        { // 我的- 个人信息 - 修改手机号
            path: '/user/ChangePhone',
            component: require('../views/user/ChangePhone')
        },
        { // 我的- 个人信息 - 修改邮箱
            path: '/user/ChangeEMail',
            component: require('../views/user/ChangeEMail')
        },
        { // 我的- 个人信息 - 修改密码
            path: '/user/ChangePassWord',
            component: require('../views/user/ChangePassWord')
        },


        { // 我的- 会员卡 - 详情
            path: '/user/VipIndex',
            component: resolve => require(['../views/user/VipCard/VipIndex'], resolve),

            // component: require('../views/user/VipCard/VipIndex'),
            children: [{
                path: 'index',
                // component: require('../views/user/VipCard/VIPBOOK')
                component: resolve => require(['../views/user/VipCard/VIPBOOK'], resolve),
            },]
        },
        { // 我的- 会员卡 - 所有会员卡信息
            path: '/user/VipMoreInfo',
            // component: require('../views/user/VipCard/VipMoreInfo'),
            component: resolve => require(['../views/user/VipCard/VipMoreInfo'], resolve),

        },
        { // 我的- 会员卡 - 升级
            path: '/user/UpdateVIP',
            // component: require('../views/user/VipCard/UpdateVIP')
            component: resolve => require(['../views/user/VipCard/UpdateVIP'], resolve),

        },



        {
            //我的 - 评论
            path: '/comments/myComments',
            component: require('../views/comments/myComments')
        },
        {
            //我的 - 写评论
            path: '/comments/writeComments',
            component: require('../views/comments/writeComments')
        },
        {
            //我的 - 追加评论
            path: '/comments/appendComments',
            component: require('../views/comments/appendComments')
        },

        { // 我的- 个人信息
            path: '/user/BaseInfo',
            component: require('../views/user/BaseInfo')
        },
        { // 我的- 个人信息 - 修改手机号
            path: '/user/ChangePhone',
            component: require('../views/user/ChangePhone')
        },
        { // 我的- 个人信息 - 修改邮箱
            path: '/user/ChangeEMail',
            component: require('../views/user/ChangeEMail')
        },
        { // 我的- 个人信息 - 修改密码
            path: '/user/ChangePassWord',
            component: require('../views/user/ChangePassWord')
        },







        // {  //  选择银行卡
        //     path: '/wallet/ChooseCard',
        //     component: require('../views/wallet/recharge/ChooseCard')
        // },
        // {  //  直接付钱
        //     path: '/wallet/DirectPay',
        //     component: require('../views/wallet/recharge/DirectPay')
        // },
        // {  //  输入卡号
        //     path: '/wallet/BeforeBind',
        //     component: require('../views/wallet/recharge/BeforeBind')
        // },
        // {   
        //     path: '/wallet/NextDebit',
        //     component: require('../views/wallet/recharge/NextDebit')
        // },
        // {
        //     path: '/wallet/NextCredit',
        //     component: require('../views/wallet/recharge/NextCredit')
        // },
        // {
        //     //钱包 -  银联支付
        //     path: '/wallet/unionPay',
        //     component: require('../views/wallet/recharge/unionPay')
        // },
        // {
        //     //钱包 -  银联支付验证
        //     path: '/wallet/unionPayValid',
        //     component: require('../views/wallet/recharge/unionPayValid')
        // },




        { // 钱包 - 充值方式
            path: '/wallet/payStyle',
            component: require('../views/wallet/recharge/payStyle')
        },
        {
            //钱包 -  银联支付成功
            path: '/wallet/paySuccess',
            component: require('../views/wallet/recharge/paySuccess')
        },
        { // 钱包 - 储值卡充值页面
            path: '/wallet/recharge',
            component: require('../views/wallet/recharge')
        },

        {
            //钱包 -  格林币明细
            path: '/wallet/coinDetail',
            component: require('../views/wallet/coinDetail')
        },
        {
            //钱包 -  银联券明细
            path: '/wallet/VISADetail',
            component: require('../views/wallet/VISADetail')
        },
        {
            //钱包 -  现金账户明细
            path: '/wallet/cashDetail',
            component: require('../views/wallet/cashDetail')
        },
        {
            //钱包 -  储值卡明细
            path: '/wallet/valueCardDetail',
            component: require('../views/wallet/valueCardDetail')
        },
        {
            //钱包 - 我的免房券
            path: '/wallet/freeVouchers',
            component: require('../views/wallet/freeVouchers')
        },
        {
            //钱包 -  储值卡未开通
            path: '/wallet/noValueCard',
            component: require('../views/wallet/noValueCard')
        },
        {
            //钱包 -  储值卡开通
            path: '/wallet/openValueCard',
            component: require('../views/wallet/openValueCard')
        },
        {
            //钱包 -  商城预存款明细
            path: '/wallet/mallDeposit',
            component: require('../views/wallet/mallDeposit')
        },
        {
            //钱包 -  商城预存款兑换
            path: '/wallet/mallDepositExchange',
            component: require('../views/wallet/mallDepositExchange')
        },
        {
            //钱包 -  代金券
            path: '/wallet/voucher',
            component: require('../views/wallet/voucher'),
            children: []
        },
        {
            //钱包 -  代金券规则
            path: '/wallet/voucher/explain',
            component: require('../views/wallet/vocherExplain')
        },
        {
            //钱包 -  储值卡规则
            path: '/wallet/valueCardRule',
            component: require('../views/wallet/valueCardRule')
        },
        {
            //钱包 -  储值卡密码重置
            path: '/wallet/valueCardPwdReset',
            component: require('../views/wallet/valueCardPwdReset')
        },
        {
            //钱包 -  我的银行卡
            path: '/wallet/myBankCards',
            component: require('../views/wallet/myBankCards')
        },
        {
            //钱包 -  添加银行卡
            path: '/wallet/addBankCard',
            component: require('../views/wallet/addBankCard')
        },
        {
            path: '*',
            redirect: '/home/index'
        },


        // {
        //     // 活动 -  抢红包
        //     path: '/Activity/AppRedBag',
        //     // component: require('../views/Activity/AppRedBag')
        //     component: resolve => require(['../views/Activity/AppRedBag'], resolve),
        // },
        // {
        //     // 活动 -  一人一次抽奖
        //     path: '/Activity/RedBagInHotel',
        //     // component: require('../views/Activity/RedBagInHotel')
        //     component: resolve => require(['../views/Activity/RedBagInHotel'], resolve),
        // },
        // {
        //     // 活动 -  邀请有礼 - 分享注册
        //     path: '/Activity/InvitationRegister',
        //     // component: require('../views/Activity/InvitationLottery/InvitationRegister')
        //     component: require('../views/Activity/InvitationLotteryNew/InviteGiftIndex')
        // },
        // {
        //     // 活动 -  邀请有礼 - 抽奖
        //     path: '/Activity/InvitationLottery',
        //     component: require('../views/Activity/InvitationLottery/InvitationLottery')
        // },
        // {
        //     // 活动 -  邀请有礼 - 抽奖
        //     path: '/Activity/InvitationList',
        //     component: require('../views/Activity/InvitationLottery/InvitationList')
        // },




        // {
        //    // 活动 -  邀请有礼 - 抽奖 2 22222222222222222
        //    path: '/Activity/InviteGiftIndex',
        //    component: require('../views/Activity/InvitationLotteryNew/InviteGiftIndex')
        // },
        // {
        //     // 活动 -  邀请有礼 - 抽奖 2 22222222222222222
        //     path: '/Activity/InviteSharePage',
        //     component: require('../views/Activity/InvitationLotteryNew/InviteSharePage')
        //  },


        // {
        //     // 活动 -  注册送50代金券
        //     path: '/Activity/RegistGiveVoucher',
        //     component: require('../views/Activity/RegistGiveVoucher')
        // },




        {
            // 其他 -  加盟格林
            path: '/home/joinGT',
            // component: require('../views/home/joinGT')
            component: resolve => require(['../views/BrandDetails/BrandIndex'], resolve),
        },
        {
            // 其他 -  自助选房(地图)
            path: '/self-helpSelectRoom/selectRoomByMap',
            component: require('../views/self-helpSelectRoom/selectRoomByMap')
            // component: resolve => require(['../views/self-helpSelectRoom/selectRoomByMap'], resolve),
        },
        {
            // 其他 -  自助选房(列表)
            path: '/self-helpSelectRoom/selectRoomByList',
            // component: resolve => require(['../views/self-helpSelectRoom/selectRoomByList'], resolve),
            component: require('../views/self-helpSelectRoom/selectRoomByList'),
        },



        // {
        //     // 活动 - 统计APP下载手机号
        //     path: '/Activity/AppDownLog',
        //     // component: require('../views/Activity/AppDownLog')
        //     component: resolve => require(['../views/Activity/AppDownLog'], resolve),
        // },


        // { //会议室预订 - 首页
        //     path: '/bookBoardroom/index',
        //     component: require('../views/bookBoardroom/index')
        // },

        // { //会议室预订 - 酒店列表
        //     path: '/bookBoardroom/list',
        //     component: require('../views/bookBoardroom/list')
        // },

        // { //会议室预订 - 会议室列表
        //     path: '/bookBoardroom/roomList',
        //     component: require('../views/bookBoardroom/roomList')
        // },

        // { //会议室预订 - 生成订单
        //     path: '/bookBoardRoom/makeOrder',
        //     component: require('../views/bookBoardRoom/makeOrder')
        // },

        // { //会议室预订 - 订单列表
        //     path: '/bookBoardRoom/orderList',
        //     component: require('../views/bookBoardRoom/orderList')
        // },

        // { //会议室预订 - 订单详情
        //     name: 'MROrderDetail',
        //     path: '/bookBoardRoom/orderDetail',
        //     component: require('../views/bookBoardRoom/orderDetail')
        // },

        // { //会议室预订 - 预订成功
        //     name: 'MROrderSuccess',
        //     path: '/bookBoardRoom/orderSuccess',
        //     component: require('../views/bookBoardRoom/orderSuccess')
        // },

        // { //会议室预订 - 支付订单
        //     name: 'MROrderPay',
        //     path: '/bookBoardRoom/orderPay',
        //     component: require('../views/bookBoardRoom/orderPay')
        // },



        { // 选择发票
            path: '/search/ChooseInvoice',
            // component: require('../views/search/ChooseInvoice')
            component: resolve => require(['../views/search/ChooseInvoice'], resolve),

        },


        // {
        //     //微信卡包 -跳转
        //     path: '/Activity/OpenidLogin',
        //     component: require('../views/Activity/WeChatCardpackage/OpenidLogin')
        // },
        // {
        //     //微信卡包 -我的K币
        //     path: '/Activity/MyKCoins',
        //     component: require('../views/Activity/WeChatCardpackage/MyKCoins')
        // },
        // {
        //     //微信卡包 -K币规则
        //     path: '/Activity/MyKRule',
        //     component: require('../views/Activity/WeChatCardpackage/MyKRule')
        // },
        // {
        //     //   微信卡包 -我的等级
        //     path: '/Activity/MyLevel',
        //     component: require('../views/Activity/WeChatCardpackage/MyLevel')
        // },



        {
            //  新闻列表
            path: '/Home/NewsCenter',
            component: require('../views/Home/NewsCenter')
        },
        {
            //  新闻详情页
            path: '/Home/NewsDetailsPage',
            component: require('../views/Home/NewsDetailsPage')
        },
        {
            //  活动列表页
            path: '/Home/ActivityList',
            component: require('../views/Home/ActivityList')
        },

        {
            //  品牌页
            path: '/Home/BrandIntroduce',
            component: require('../views/Home/BrandIntroduce')
        },
        {
            //  非会员订单列表
            path: '/Home/OtherPage',
            component: require('../views/Home/OtherPage')
        },





        // 钱包-现金券-提现
        {
            path: '/wallet/cashExtractCash',
            // component: require('../views/wallet/cashExtractCash')
            component: resolve => require(['../views/wallet/cashExtractCash'], resolve),
        },






        /*{ 
            //404
            path: '*', 
            component: NotFoundComponent 
        }*/
        //404测试用
        {
            path: '/Err/404',
            component: require('../views/err/404'),
        },
        {
            path: '/order/wepay',
            component: require('../views/order/wepay'),
        },
        {
            path: '/wxOauth',
            component: require('../views/user/wxOauth'),
        },
        {
            path: '/wxOauthResult',
            component: require('../views/user/wxOauthResult'),
        },
        {
            path: '/checkWXBind',
            component: require('../views/user/checkWXBind'),
        },
        {
            path: '/checkWXBindResult',
            component: require('../views/user/checkWXBindResult'),
        },
        {
            path: '/wxBind/forgetPass',
            component: require('../views/user/NonVerified/wxBindForgetPass')
        },
        {
            path: '/wxUnBind',
            component: require('../views/user/wxUnBind')
        },
        //会员卡兑换
        {
            path: '/user/CreateCard',
            component: require('../views/user/NonVerified/CreateCard')
        },
        //品牌介绍首页
        {
            path: '/BrandDetails/BrandIndex',
            component: require('../views/BrandDetails/BrandIndex')
        },
        //格林豪泰品牌详情
        {
            path: '/BrandDetails/ShellDetail',
            component: require('../views/BrandDetails/ShellDetail')
        },
        //格林联盟品牌详情
        {
            path: '/BrandDetails/GmengDetail',
            component: require('../views/BrandDetails/GmengDetail')
        },
        //贝壳品牌详情
        {
            path: '/BrandDetails/BeikeDetail',
            component: require('../views/BrandDetails/BeikeDetail')
        },
        //格林东方品牌详情
        {
            path: '/BrandDetails/EastDetail',
            component: require('../views/BrandDetails/EastDetail')
        },
        //格美品牌详情
        {
            path: '/BrandDetails/GemeiDetail',
            component: require('../views/BrandDetails/GemeiDetail')
        },
        //格菲品牌详情
        {
            path: '/BrandDetails/GefeiDetail',
            component: require('../views/BrandDetails/GefeiDetail')
        },
        //格雅品牌详情
        {
            path: '/BrandDetails/GeyaDetail',
            component: require('../views/BrandDetails/GeyaDetail')
        },
        //青皮树品牌详情
        {
            path: '/BrandDetails/GreenTreeDetail',
            component: require('../views/BrandDetails/GreenTreeDetail')
        },
        //酒店用户连网登入Wifi后的门户页面 Wifiportal
        {
            path: '/user/Wifiportal',
            component: require('../views/user/Wifiportal')
        },
        // //飞常准开通成功页面
        // {
        //     path: '/Activity/FlyOpenSuccess',
        //     component: require('../views/Activity/FlyOfterAssociate/OpenSuccess')
        // },

        // //飞常准首页页面
        // {
        //     path: '/Activity/FlyIndex',
        //     component: require('../views/Activity/FlyOfterAssociate/FlyIndex')
        // },

        // //手机号开通页面  FlyOpen
        //  {
        //     path: '/Activity/FlyOpen',
        //     component: require('../views/Activity/FlyOfterAssociate/FlyOpen')
        // },
        //激活
        {
            path: '/user/Activation',
            name: 'Activation',
            component: require('../views/user/NonVerified/Activation')
        },

        //飞常准开通成功页面
        {
            path: '/Activity/FlyOpenSuccess',
            component: require('../views/Activity/FlyOfterAssociate/OpenSuccess')
        },

        // 联合登录 - 联动云跳转i站
        {
            path: '/uniteLogin/ldyBridge',
            component: require('../views/uniteLogin/ldyBridge')
        },

        // 华铁传媒
        {
            path: '/tmpAc/HuaTie18',
            component: require('../views/Activity/2018HuaTie/index')
        },
        {
            path: '/ReviewCheck',
            component: require('../views/user/ReviewCheck')
        },
        {
            path:'/ReviewCheckResult',
            component: require('../views/user/ReviewCheckResult')
        }


    ]
})


//＃号过滤
router.beforeEach((to, from, next) => {

    var url = to.fullPath;
    var newgo = window.location.protocol + "//" + window.location.host + "/Activity.html?returnURL="
        + to.fullPath;

    // console.log(url)
    // console.log(newgo)

    if (url.indexOf('/activity/') != -1 || url.indexOf('/Activity/') != -1) {
        if (url.indexOf('?returnURL') == -1) {
            window.location.href = newgo;
            // window.location.replace(newgo);
            return;
        }
    }

    router.gxxfrom = from;
    if (to.hash.indexOf('#/') == 0) {
        next(to.hash.substring(1))
    } else {
        next()
    }
})
export default router


// WEBPACK FOOTER //
// ./src/router/router.js